import { render, staticRenderFns } from "./limit-extension-application.vue?vue&type=template&id=4acd4452"
import script from "./limit-extension-application.vue?vue&type=script&lang=js"
export * from "./limit-extension-application.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports